/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { convertToImperial } from '@sportninja/common/reducers/helpers'
import dayjs from 'dayjs'

import {
  ColumnHeightOutlined,
  GiftOutlined,
  UserOutlined,
} from '@ant-design/icons'
import Text from '../ts-components/Text'
import colors from '@sportninja/common/constants/appColors'

const Bio = ({ birthDate, height, weight }) => {
  const [ft, inches] = convertToImperial(height)
  const age = dayjs().diff(birthDate, 'year')

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 16px;
      `}
    >
      {birthDate ? (
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 4px;
          `}
        >
          <GiftOutlined
            css={css`
              color: ${colors.NEUTRAL_100};
              font-size: 16px;
            `}
          />
          <Text
            variant='paragraphSmall'
            weight='regular'
            color={colors.NEUTRAL_0}
          >
            {age}
          </Text>
        </div>
      ) : null}
      {height ? (
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 4px;
          `}
        >
          <ColumnHeightOutlined
            css={css`
              color: ${colors.NEUTRAL_100};
              font-size: 16px;
            `}
          />
          <Text
            variant='paragraphSmall'
            weight='regular'
            color={colors.NEUTRAL_0}
          >
            {ft}&apos;{inches}&quot;
          </Text>
        </div>
      ) : null}
      {weight ? (
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 4px;
          `}
        >
          <UserOutlined
            css={css`
              color: ${colors.NEUTRAL_100};
              font-size: 16px;
            `}
          />
          <Text
            variant='paragraphSmall'
            weight='regular'
            color={colors.NEUTRAL_0}
          >
            {weight} lbs
          </Text>
        </div>
      ) : null}
    </div>
  )
}

export default Bio
